import { useMutation } from "react-query";

import transactionsService from "api/transactionsService";
import { IRefundTransactionQueryParams } from "types/transaction";

const useRefundTransaction = ()=> {
  return useMutation(async(params: IRefundTransactionQueryParams) => {
    try {
      const res = await transactionsService.refundTransaction(params)

      return res.data
    } catch (err: any) {
      return {
        err: err.message,
        errStatus: err.response.status,
      }
    }
  })
}

export default useRefundTransaction